import classNames from 'classnames';
import { arrayOf, bool, node, object, shape, string } from 'prop-types';
import React from 'react';
import { useSweLang } from '../Helpers/helpers';
import Video from '../Video';
import RegionLabel from './regionlabel';

const ArticleTags = (props) => {
  const tags = props.Content.ArticleTags;
  return (
    <div className="c-articletags__container">
      {tags.map((item, key) => {
        return (
          <div className="article-tag" key={key}>
            {item}
          </div>
        );
      })}
    </div>
  );
};

const ArticleVideoWrapper = ({ TopMediaVideo, isAboveTitle }) => {
  return (
    <div
      className={`c-articleheader__video-wrapper ${
        isAboveTitle ? 'isAboveTitle' : ''
      }`}
    >
      {TopMediaVideo && <Video {...TopMediaVideo} />}
    </div>
  );
};

const ArticleHeader = (props) => {
  const componentClasses = classNames({
    'c-articleheader': true,
    ...props.Modifiers,
    'c-articleheader--has-regionlabel':
      props.Content && props.Content.CurrentRegionName,
    'c-articleheader--has-subject':
      props.Content &&
      props.Content.SubjectHeading &&
      !props.Content.HideSubjectHeading,
  });

  const showSubject =
    props.Content &&
    props.Content.SubjectHeading &&
    !props.Content.HideSubjectHeading;

  const dataPrintSidebarTitle = {
    heading: 'Rubrik',
    preamble: 'Inledning',
  };

  return (
    <header className={componentClasses}>
      {props.isFaqPage && (
        <span className="c-articleheader__vignette">
          {props.Content.Translations.question}
        </span>
      )}

      <div className="c-articleheader__inner-container">
        {showSubject && props.SubjectAboveHeading && (
          <a
            className="c-articleheader__subject"
            href={
              props.Content.SubjectHeadingLink &&
              props.Content.SubjectHeadingLink
            }
          >
            {props.Content.SubjectHeading}
          </a>
        )}

        {props.Content?.VideoAboveTitle && props.Content?.TopMediaVideo && (
          <ArticleVideoWrapper
            TopMediaVideo={props.Content.TopMediaVideo}
            isAboveTitle={props.Content.VideoAboveTitle}
          />
        )}

        {props.Content && props.Content.ArticleTags && (
          <ArticleTags {...props} />
        )}

        {props.Heading && (
          <h1
            className="c-articleheader__heading"
            data-print-sidebar-title={dataPrintSidebarTitle.heading}
          >
            {props.Heading}
          </h1>
        )}

        {props.HeadingTranslation && (
          <span
            className="c-articleheader__translation"
            dir="ltr"
            lang={useSweLang(props.Language)}
          >
            {props.HeadingTranslation}
          </span>
        )}

        {props.Content && props.Content.CurrentRegionName && (
          <RegionLabel {...props} useIdsBadge={props?.Site === '1177'} />
        )}

        {showSubject && !props.SubjectAboveHeading && (
          <a
            className={classNames({
              'c-articleheader__subject': true,
              'c-articleheader__subject--hidden':
                props.PageTypeName === 'CollectionPage',
            })}
            href={
              props.Content.SubjectHeadingLink &&
              props.Content.SubjectHeadingLink
            }
          >
            {props.Content.SubjectHeading}
          </a>
        )}

        {!props.Content?.VideoAboveTitle && props.Content?.TopMediaVideo && (
          <ArticleVideoWrapper TopMediaVideo={props.Content.TopMediaVideo} />
        )}

        {props.Preamble && (
          <p
            className="preamble"
            data-print-sidebar-title={dataPrintSidebarTitle.preamble}
          >
            {props.Preamble}
          </p>
        )}

        {props.children}
      </div>
    </header>
  );
};

ArticleHeader.propTypes = {
  Preamble: node,
  children: node,
  isFaqPage: bool,
  PageTypeName: string,
  /** Classnames compatible object */
  Modifiers: object,
  Heading: node,
  HeadingTranslation: node,
  Translations: shape({
    question: string,
  }),
  Content: shape({
    ArticleTags: arrayOf(string),
    SubjectHeadingLink: string,
    SubjectHeading: string,
    CurrentRegionName: node,
    HideSubjectHeading: bool,
  }),
  SubjectAboveHeading: bool,
};

export default ArticleHeader;
